// Error messages
export var GENERIC_ERROR = "Something went wrong. Please try again."; // Payment method action prompts and alerts

export var CREDIT_CARD_REMOVAL_CONFIRMATION_PROMPT = "You are about to remove this card from your account. Do you wish to continue?";
export var CREDIT_CARD_REMOVAL_SUCCESS_ALERT = "Your card has been deleted from your account.";
export var CREDIT_CARD_ADDITION_SUCCESS_ALERT = "Your card has been saved to your account."; // Assets

export var IMG_CCV_MODAL_INSTRUCTION = "https://s.catch.com.au/assets/0001/1044/64af4b07a6cda644446055.webp"; // Alert timeouts

export var DEFAULT_ALERT_TIMEOUT = 5000;